module.exports = __webpack_public_path__ + "img/empilhadeiras_pag8_SMALL.3ebb7d71.jpeg";